import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as Highcharts from 'highcharts';
import HighchartsExporting from 'highcharts/modules/exporting';
import HC_more from 'highcharts/highcharts-more';
import { LoaderService } from './loader.service';
import { VolumeForecastingRowDataI } from './../constants/constants';
import { volumeForecastingSetting } from '../constants/ticket-analysis.constansts';
HighchartsExporting(Highcharts);
HC_more(Highcharts)

  ; (function (Highcharts: any) {
    /**
     * Create a global getSVG method that takes an array of charts as an
     * argument
     */
    Highcharts.getSVG = function (charts: any) {
      // eslint-disable-next-line prefer-const
      let svgArr: any[] = [],
        top = 0,
        width = 0,
        endWidth = 0;

      Highcharts.each(charts, function (chart: any) {
        let svg = chart.getSVG(),
          // Get width/height of SVG for export
          // eslint-disable-next-line prefer-const
          svgWidth = +svg.match(/^<svg[^>]*width\s*=\s*\"?(\d+)\"?[^>]*>/)[1],
          // eslint-disable-next-line prefer-const
          svgHeight = +svg.match(/^<svg[^>]*height\s*=\s*\"?(\d+)\"?[^>]*>/)[1];

        svg = svg.replace('<svg', '<g transform="translate(' + width + ', ' + top + ')" ');

        svg = svg.replace('</svg>', '</g>');

        width += svgWidth;
        endWidth = Math.max(endWidth, width);

        if (width === 2 * svgWidth) {
          width = 0;
          top += svgHeight;
        }

        svgArr.push(svg);
      });
      top += 400;
      return (
        '<svg height="' +
        top +
        '" width="' +
        endWidth +
        '" version="1.1" xmlns="http://www.w3.org/2000/svg">' +
        svgArr.join('') +
        '</svg>'
      );
    };

    /**
     * Create a global exportCharts method that takes an array of charts as an
     * argument, and exporting options as the second argument
     */
    Highcharts.exportCharts = function (charts: any, options: any) {
      charts.forEach(function (chart: any) {
        chart.update({
          chart: {
            borderColor: 'grey',
            borderWidth: 1.5,
          },
          credits: {
            enabled: false,
          },
        });
      });

      // Merge the options
      options = Highcharts.merge(Highcharts.getOptions().exporting, options);

      // Post to export server
      Highcharts.post(options.url, {
        filename: options.filename || 'chart',
        type: options.type,
        width: options.width,
        svg: Highcharts.getSVG(charts),
      });
    };
  })(Highcharts);

@Injectable({
  providedIn: 'root'
})
export class VolumeForecastingService {
  public emitSelectedReqHistorySource: Subject<VolumeForecastingRowDataI> = new Subject();
  public selectedTicketRequestRow!: VolumeForecastingRowDataI;
  private selectedRequestSubject: Subject<VolumeForecastingRowDataI> = new Subject();
  private selectedTicketResponseSubject: Subject<any> = new Subject<any>();
  deleteForecastingModal = new BehaviorSubject<any>(null);

  private apiUrl = environment.apiUrl;
  private chartConfigDetails = [
    { dataField: 'volumeForecasting', settings: volumeForecastingSetting },
  ];
  constructor(private http: HttpClient, private loaderService: LoaderService) { }

  submit(clientName: string, file: File, emailId: any, notify: any ,submitterName :any): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('clientName', clientName);
    formData.append('multipartFile', file, file.name);
    formData.append('emailId', emailId);
    formData.append('notify', notify);
    formData.append('submitter',submitterName)
    const headers = new HttpHeaders(); // Add headers if needed
    const url = `${this.apiUrl}/aipo/ticket/analysis/api/volume/submit`;
    return this.http.post(url, formData, { headers: headers });
  }

  getHistory(): Observable<any> {
    const url = `${this.apiUrl}/aipo/ticket/analysis/api/volume/requestList`;
    return this.http.get(url);
  }

  public emitSelectedRequestHistory(record: VolumeForecastingRowDataI): void {
    this.emitSelectedReqHistorySource.next(record);
  }

  public getSelectedForecastDetails(requestId: string): Observable<any> {
    const url = `${this.apiUrl}/aipo/ticket/analysis/api/volume/report?requestId=${requestId}`;

    return this.http.get(url).pipe(
      map((response: any) => {
        return response;
      })
    );
  }
  public setSelectedTestDesignRow(row: VolumeForecastingRowDataI, returnObservalbe = false): Observable<any> | void {
    this.selectedTicketRequestRow = row;
    this.selectedRequestSubject.next(row);

    if (returnObservalbe) {
      return this.getSelectedForecastDetails(row.requestId);
    }

    if (row) {
      this.getSelectedForecastDetails(row.requestId).subscribe((res: any) => {
        this.selectedTicketResponseSubject.next(res);
      });
    }
  }

  public getSelectedResponse(): Observable<any> {
    return this.selectedTicketResponseSubject.asObservable();
  }

  public getSelectedRequest() {
    return this.selectedTicketRequestRow;
  }

  public deleteForecastingDetails(requestId: any): Observable<any> {
    const url = `${this.apiUrl}/aipo/ticket/analysis/api/volume/delete?requestId=${requestId}`;
    return this.http.delete(url).pipe(
      map((response: any) => {
        return response;
      })
    );
  }
  public downloadUploadVolumeForecastingFile(requestId: any): Observable<any> {
    const url = `${this.apiUrl}/aipo/ticket/analysis/api/volume/download-file?requestId=${requestId}`;
    return this.http.get(url, { responseType: 'blob' }).pipe(
      map((response: any) => {
        return response;
      })
    );
  }
  public setOptionsForChart(response: any, settings: any) {
    if (Array.isArray(response) && response.length > 0) {
      const nonZeroValues = response.filter((item: any) => item.actualVolume !== 0);
      const combinedData = response.map((item: any) => {
        const dataPoint: any = {
          name: item.date,
          y: item.actualVolume !== 0 ? item.actualVolume : item.forecastedTicketVolume,
          type: item.actualVolume !== 0 ? settings.type1 : settings.type2,
          color: item.actualVolume !== 0 ? settings.color1 : settings.color2,
          dashStyle: item.actualVolume !== 0 ? undefined : 'Dash',
        };
        return dataPoint;
      });

      const options: any = {
        exporting: {
          enabled: true,
          chartOptions: {
            plotOptions: {
              pie: {
                dataLabels: {
                  enabled: true,
                  format: '{point.name}: {point.y:.2f}%'
                }
              },

              line: {
                dataLabels: {
                  enabled: true,
                  format: '{point.name}: {point.y:.2f}%'
                }
              },

            }
          }
        },
        title: {
          text: settings.title,
        },
        xAxis: {
          lineWidth: 0,
          minorGridLineWidth: 0,
          lineColor: 'transparent',
          categories: response.map((item: any) => item.date),
          title: {
            text: settings.xaxisTitle || '',
          },
        },
        yAxis: {
          title: {
            text: settings.yaxisTitle,
          },
        },
        credits: {
          enabled: false,
        },
        legend: {
          itemStyle: {
            cursor: 'default',
            pointerEvents: 'none',
          },
        },
        series: [
          {
            name: settings.name1,
            color: settings.color1,
            data: combinedData,
            type: 'line',
            marker: {
              symbol: 'circle',
              radius: 4,
              color: '#FFF',
            },
            zoneAxis: 'x',
            zones: [{
              value: nonZeroValues.length - 1,
            }, {
              dashStyle: 'Dash',
              color: settings.color2,
              name: settings.name2,
            }],
          },
          {
            name: settings.name2,
            color: settings.color2,
          },
        ],
      };
      options.plotOptions = {
        line: {
          dataLabels: {
            enabled: false,
            format: '{point.y}',
          },
          tooltip: {
            pointFormat: ' {point.y:.2f} {point.custom.unit}',
          },
          colors: [settings.color1, settings.color2],
          showInLegend: true,
          jitter: {
            x: 0.14,
            y: 0,
          },
          marker: {
            radius: 4,
            symbol: 'circle',
            innerSize: '70%',
            color: '#FFF',
          },
        },
      };

      return options;
    }
  }
  createAndExportVolumeForecastingCharts(data: any,filename:string) {
    this.loaderService.show();
    const readyCharts2Export: object[] = [];
    this.chartConfigDetails.forEach((chartConfig) => {
      const chartData = data[chartConfig.dataField];
      const settings = chartConfig.settings;
      const chartsOptions = this.setOptionsForChart(chartData, settings);

      if (chartsOptions) {
        readyCharts2Export.push(Highcharts.chart(document.createElement('div'), chartsOptions));
      }
    })
      ; (Highcharts as any).exportCharts(readyCharts2Export, {
        type: 'application/pdf',
        filename:filename
      });
    setTimeout(() => {
      this.loaderService.hide();
    }, 1000);
  }
}
